import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
// https://www.positronx.io/ionic-sqlite-database-crud-app-example-tutorial/
import { inject } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { StorageService } from './StorageService';

export class StorageSQLiteService extends StorageService {
  // inject() funciona aquí porque la clase se construye dentro del
  // useFactory de StorageProvider (contexto de inyección)
  private platform = inject(Platform);

  private _sqliteReady: Promise<Storage> | null = null;

  // En nativo el driver SQLite solo existe tras platform.ready();
  // registrarlo antes haría caer a IndexedDB silenciosamente y los
  // datos quedarían divididos entre dos backends.
  protected override ready(): Promise<Storage> {
    if (!this._sqliteReady) {
      this._sqliteReady = this.platform
        .ready()
        .then(() => this.storage.defineDriver(CordovaSQLiteDriver))
        .then(() => this.storage.create());
    }
    return this._sqliteReady;
  }
}
